import React, { Component } from 'react';
import { connect } from 'react-redux';
import { api } from '../../../config';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './HomeItem.css';
import Col from 'react-bootstrap/Col';
import cx from 'classnames';
export class HomeItem extends Component {
    render() {
        const { item } = this.props;

        return (

            <div>
                <Col xs={12} sm={12} md={12} lg={12} className={cx(s.sliderBox, s.tabPaddingTop)}>
                    <div className={s.sliderBg} style={{ backgroundColor: item.iconBackgroundColor }}>
                        <div className={s.previewIcon} style={{ backgroundImage: `url(${api.apiEndpoint + "/images/delivery-type/medium_" + item.imageName})` }} />
                    </div>
                    <div className={s.sliderBottom}>
                        <div className={s.bgColor} style={{ backgroundColor: item.backgroundColor }}>
                            <div className={s.previewHeading} style={{ color: item.textColor }}>{item.deliveryName}</div>
                            <div className={s.previewContent} style={{ color: item.textColor }}>{item.deliveryDescription}</div>
                        </div>
                    </div>
                </Col>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default withStyles(s)(connect(mapStateToProps, mapDispatchToProps)(HomeItem)) 
